import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Users, Star, Clock } from 'lucide-react';
const stats = [{
  icon: Calendar,
  value: '5+',
  label: '年行业经验',
  subLabel: 'Years Experience'
}, {
  icon: Users,
  value: '2000+',
  label: '满意客户',
  subLabel: 'Happy Clients'
}, {
  icon: Star,
  value: '20+',
  label: '专业技师',
  subLabel: 'Expert Therapists'
}, {
  icon: Clock,
  value: '24/7',
  label: '全天候服务',
  subLabel: 'Service Hours'
}];
export function AboutUs() {
  return <section id="about" className="py-24 bg-white" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-14">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-15">
              关于幸福缘
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium mb-6" data-id="element-16">
              About Happiness Connection
            </p>
            <div className="w-20 h-1 bg-[#c9a96e] mb-8" data-id="element-17" />

            <div className="space-y-6 text-gray-600 leading-relaxed text-lg" data-id="element-18">
              <p data-id="element-19">
                幸福缘成立于新加坡，是一家专注于高端按摩与伴游服务的专业平台。我们汇聚了来自各地的优秀技师，以精湛的技艺和贴心的服务，为每一位客户带来身心的极致放松。
              </p>
              <p data-id="element-20">
                我们深知，在繁忙的都市生活中，每个人都需要一个放松身心的港湾。幸福缘正是为此而生——我们不仅提供专业的按摩服务，更致力于打造一种尊贵、私密、舒适的全方位体验。
              </p>
              <p data-id="element-21">
                从精心挑选的技师团队，到量身定制的服务方案，从严格的隐私保护，到24小时不间断的贴心服务，幸福缘的每一个细节都彰显着我们对品质的执着追求。
              </p>
            </div>
          </motion.div>

          {/* Image / Visual Element */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-22">
            <div className="aspect-[4/5] rounded-sm overflow-hidden relative group" data-id="element-23">
              <div className="absolute inset-0 bg-[#1a1a2e]/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-24" />
              <img src="https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Spa and Wellness" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-25" />
              {/* Decorative border */}
              <div className="absolute inset-4 border border-white/50 z-20 pointer-events-none" data-id="element-26" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-8 -left-8 bg-[#1a1a2e] text-white p-6 rounded-sm shadow-xl hidden md:block" data-id="element-27">
              <p className="text-[#c9a96e] font-serif text-3xl font-bold mb-1" data-id="element-28">
                Premium
              </p>
              <p className="text-sm tracking-widest uppercase" data-id="element-29">
                Wellness Experience
              </p>
            </div>
          </motion.div>
        </div>

        {/* Stats Row */}
        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-30">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center group" data-id="element-31">
              <div className="w-16 h-16 mx-auto bg-[#faf7f2] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a96e] transition-colors duration-300" data-id="element-32">
                <stat.icon className="text-[#c9a96e] group-hover:text-white transition-colors duration-300" size={32} data-id="element-33" />
              </div>
              <h3 className="text-4xl font-serif font-bold text-[#1a1a2e] mb-2" data-id="element-34">
                {stat.value}
              </h3>
              <p className="text-gray-800 font-medium mb-1" data-id="element-35">{stat.label}</p>
              <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-36">
                {stat.subLabel}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}